module.exports = __webpack_public_path__ + "img/BS07.75ccb1ea.svg";